/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Performance_TodayInputs */

const vi_dashboard_driver_performance_today = /** @type {(inputs: Dashboard_Driver_Performance_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu suất hôm nay`)
};

/**

* @param {Dashboard_Driver_Performance_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_performance_today = /** @type {((inputs?: Dashboard_Driver_Performance_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Performance_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_performance_today(inputs)
});